export type SpotifyUriType = 'track' | 'album' | 'artist' | 'playlist';

export const okResponse = <T>(data: T) => Promise.resolve({ data });

export const spotifyUri = (type: SpotifyUriType, id: string) =>
  `spotify:${type}:${id}`;

export const urisParameter = (
  type: SpotifyUriType,
  ids: string | string[]
): string => {
  const idList = Array.isArray(ids) ? ids : ids.split(',').filter(Boolean);
  return idList.map((id) => spotifyUri(type, id.trim())).join(',');
};

export const emptyRelatedArtistsResponse = { artists: [] as never[] };

export const emptyTopTracksResponse = { tracks: [] as never[] };

export const emptyFeaturedPlaylistsResponse = {
  message: 'Featured playlists',
  playlists: {
    href: '',
    limit: 0,
    next: '',
    offset: 0,
    previous: '',
    total: 0,
    items: [] as never[],
  },
};

export const emptyNewReleasesResponse = {
  albums: {
    href: '',
    limit: 0,
    next: '',
    offset: 0,
    previous: '',
    total: 0,
    items: [] as never[],
  },
};

export const emptyContainsResponse = () => okResponse<boolean[]>([]);
